import React from 'react';

const BookingModal = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: BookingModal is not implemented yet.');
  }, []);
  return (
    <>
  { /*BookingModal */} 
 </>
  );
};

export default BookingModal;
